export default {
    // 邮件配置
    MAIL_PROPERTIES: "邮件配置",
    MAIL_PROPERTIES_CREATE: "新建邮件配置",
    MAIL_PROPERTIES_CREATE_SUCCESS: "新建邮件配置成功",
    MAIL_PROPERTIES_UPDATE: "更新邮件配置",
    MAIL_PROPERTIES_UPDATE_SUCCESS: "更新邮件配置成功",
    MAIL_PROPERTIES_USERNAME: "账号",
    MAIL_PROPERTIES_USERNAME_REQUIRED: "邮件配置账号不能为空",
    MAIL_PROPERTIES_PASSWORD: "密码",
    MAIL_PROPERTIES_MAIL_HOST: "主机名",
    MAIL_PROPERTIES_MAIL_HOST_REQUIRED: "邮件配置主机名不能为空",
    MAIL_PROPERTIES_MAIL_FROM: "发件人",
    MAIL_PROPERTIES_MAIL_FROM_REQUIRED: "邮件配置发件人不能为空",
    MAIL_PROPERTIES_MAIL_PORT: "端口",
    MAIL_PROPERTIES_MAIL_PORT_REQUIRED: "邮件配置端口不能为空",
    MAIL_PROPERTIES_SMTP_AUTH: "认证",
    MAIL_PROPERTIES_SMTP_SSL: "SSL",

    // 邮件模版
    MAIL_TEMPLATE: "邮件模版",
    MAIL_TEMPLATE_CREATE: "新建邮件模版",
    MAIL_TEMPLATE_CREATE_SUCCESS: "新建邮件模版成功",
    MAIL_TEMPLATE_UPDATE: "更新邮件模版",
    MAIL_TEMPLATE_UPDATE_SUCCESS: "更新邮件模版成功",
    MAIL_TEMPLATE_CODE: "编号",
    MAIL_TEMPLATE_CODE_REQUIRED: "邮件模版编号不能为空",
    MAIL_TEMPLATE_NAME: "名称",
    MAIL_TEMPLATE_NAME_REQUIRED: "邮件模版名称不能为空",
    MAIL_TEMPLATE_MAIL_FROM: "发件人",
    MAIL_TEMPLATE_MAIL_FROM_REQUIRED: "邮件模版发送者不能为空",
    MAIL_TEMPLATE_MAIL_TO: "收件人",
    MAIL_TEMPLATE_MAIL_TO_REQUIRED: "邮件模版收件人不能为空",
    MAIL_TEMPLATE_MAIL_CC: "抄送",
    MAIL_TEMPLATE_MAIL_BCC: "密送",
    MAIL_TEMPLATE_MAIL_TITLE: "标题",
    MAIL_TEMPLATE_MAIL_CONTENT: "内容",
    MAIL_TEMPLATE_VERIFY_CODE_SEND_SUCCESS: "邮件验证码发送成功",
};
